import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './FootprintApiManager.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_get_contacts_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { filters: { contact_ids?: number[], owner_entities?: string[], address_ids?: number[], first_names?: string[], last_names?: string[] } }): Promise<{ contacts?: $frontendTypes.FootprintApiManager.public_contact[], errors?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.filters)) {
      missingRequiredInParams.push('\'filters\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

}

